import {ComponentType} from 'react';

import createRoute from './create/routes';
import editRoute from './edit/routes';

import IconData from '../../../assets/icon_data.svg?react';
import loadable from '../../../utils/loadable';
import {
	AUTHORITY_CREATE_KPI_DATA_PROCESSING_DEFINITION,
	AUTHORITY_READ_KPI_DATA_PROCESSING_DEFINITION,
	AUTHORITY_UPDATE_KPI_DATA_PROCESSING_DEFINITION
} from '../../../modules/common/consts';

const GlobalDataProcessingDefinitionsListPage: ComponentType<unknown> = loadable({
	loader: () => import('../../../modules/dataprocessingdefinitions/global/GlobalDataProcessingDefinitionsList')
});

export default {
	relativePath: 'globaldataprocessingdefinitions',
	label: {
		id: 'route.label.globaldataprocessingdefinitions.name',
		defaultValue: 'Data Processing Definitions'
	},
	component: GlobalDataProcessingDefinitionsListPage,
	requiredAuthorities: [
		AUTHORITY_READ_KPI_DATA_PROCESSING_DEFINITION,
		AUTHORITY_CREATE_KPI_DATA_PROCESSING_DEFINITION,
		AUTHORITY_UPDATE_KPI_DATA_PROCESSING_DEFINITION,
		'READ_ASSET',
		'READ_ASSET_GROUP',
		'READ_ACCOUNT_GROUP'
	],
	iconSvg: IconData,
	childRoutes: [createRoute, editRoute]
};
